import React, { Component } from 'react';
import Sheet from './sheet';

class SheetsRow extends Component {
    state = {
        examInfo: [
            {id: 1, examNum: '①', text: '증가한다.'},
            {id: 2, examNum: '②', text: '감소한다.'},
            {id: 3, examNum: '③', text: '똑같다.'},
            {id: 4, examNum: '④', text: '증가하다가 감소한다.'},
            {id: 5, examNum: '⑤', text: '알 수 없다.'}
        ],
        refValue: ''
    };
    handleSheetSelect = (event) => {
        console.log('sdgjli');
    };
    render() {
        return (
            <li className="sheet-component-container only-select-container">
                <button type="button" className="btn exam-bnt">{this.props.examNum}</button>
                <form className="exam-group">
                    <div>
                        {this.state.examInfo.map(item => (
                            <Sheet info={item} onSheetSelect={this.handleSheetSelect} />
                        ))}
                    </div>
                </form>
            </li>
        );
    }
}

export default SheetsRow;